import React from 'react';

function Footer() {
  const cols = [
    { h: "Company", l: ["Home", "About Us", "Portfolio", "Careers", "Blog"] },
    {
      h: "Services",
      l: [
        "Augmented Reality",
        "Social Media",
        "Game Dev",
        "Blockchain",
        "Mobile Apps",
      ],
    },
    {
      h: "Solutions",
      l: [
        "Virtual Reality",
        "Digital Marketing",
        "Web Applications",
        "Mixed Reality",
        "Holograms",
      ],
    },
  ];
  return (
    <footer className="ftr">
      <div className="ftr-in">
        <div data-stagger className="ftr-grid">
          <div>
            <div className="ftr-logo">
              Viz<em>infy</em>
            </div>
            <p className="ftr-tag">
              Building the technology that powers tomorrow's most ambitious
              businesses.
            </p>
            <div className="ftr-socs">
              {["𝕏", "in", "f", "▶"].map((s, i) => (
                <button key={i} className="fsoc">
                  {s}
                </button>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.h}>
              <p className="ftr-col-h">{c.h}</p>
              <div className="ftr-links">
                {c.l.map((l) => (
                  <a key={l} href="#">
                    {l}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div data-reveal="fade-up" data-delay="200" className="ftr-bottom">
          <span>© 2024 Vizinfy. All rights reserved.</span>
          <div className="gap-20">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;